import { GenerateBotNameProps } from './types'
import { SettingsPopupOpenSection } from '../../../store/modals'

export function getInitialFormData(openSection: SettingsPopupOpenSection) {
  if (openSection === 'form') {
    return {
      client: '',
      category: 'feedie',
      shortDescription: '',
      type: 'chat'
    }
  }

  return {
    client: '',
    category: '',
    shortDescription: '',
    type: ''
  }
}

export const schema = {
  type: 'object',
  title: 'Enter bot parameters',
  properties: {
    type: {
      type: 'string',
      default: 'chat',
      title: 'Bot type',
      enum: ['chat', 'voice']
    },
    client: {
      type: 'string',
      title: 'Client'
    },
    category: {
      type: 'string',
      default: 'feedie',
      title: 'Category',
      enum: [
        'hr-recruitment',
        'hr-preboarding',
        'hr-onboarding',
        'hr-helpdesk',
        'hr-offboarding',
        'hr-feedback',
        'lead',
        'faq',
        'feedback',
        'helpdesk',
        'box',
        'feedie',
        'trial',
        'custom'
      ]
    },
    shortDescription: {
      type: 'string',
      title: 'Short description'
    },
    expectedId: {
      readOnly: true,
      type: 'string',
      title: 'Bot name',
      description: 'This will be the bot name, if the current changes were be saved.'
    }
  }
} as const

export function generateBotName(prop: GenerateBotNameProps) {
  return [prop.client, prop.category, prop.shortDescription, prop.type]
    .filter(prop => !!prop?.trim())
    .join(' ')
}
